import { PureComponent } from "react";

import {
    type LinkedScheduleItemStatus,
    LinkedScheduleItemStatusTag,
} from "commonComponents/entity/linkedScheduleItem/LinkedScheduleItemStatusTag";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

export class LinkedScheduleItemStatusCell extends PureComponent<
    IGridCellRenderProps<LinkedScheduleItemStatus>
> {
    render() {
        const { cellValue, field } = this.props;
        if (!cellValue) {
            return null;
        }
        return (
            <div data-testid={field.full}>
                <LinkedScheduleItemStatusTag status={cellValue} />
            </div>
        );
    }
}

export const columnLinkedScheduleItemStatus: IClientGridColumn<LinkedScheduleItemStatus> = {
    columnType: GridColumnType.linkedScheduleItemStatus,
    Cell: LinkedScheduleItemStatusCell,
};
